import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = 'resttosoaplib'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/resttosoaplib`

class RestToSoapService {
  about () {
    return Api().get(`${clientRoot()}/about`)
  }

  insert (item) {
    return Api().post(root, item)
  }

  update (item) {
    return Api().put(root, item)
  }

  findAll () {
    return Api().get(`${clientRoot()}`)
  }

  delete ({ nameMethod }) {
    return Api().delete(`${clientRoot()}/${nameMethod}`)
  }

  findById (id) {
    const url = `${clientRoot()}/${id}`
    return Api().get(url)
  }
}

export default new RestToSoapService()
